import { flatten, map } from 'lodash';
import { device, getSpaces, getCAPAlerts } from '../services/endpoints';

export default {
  async connect({ dispatch }, screenIdNo) {
    await dispatch('fetchToken', screenIdNo);
    await dispatch('registerDevice');
  },

  async fetchToken({ state, commit }, screenIdNo) {
    if (!state.isOfflineMode) {
      return device.connect(screenIdNo).then(({ data }) => {
        commit('setToken', data.result.access_token);
        localStorage.setItem('token', data.result.access_token);
        Promise.resolve(data.result.access_token);
      }).catch(err => Promise.reject(err));
    }

    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token');
      if (token) {
        commit('setToken', token);
        resolve(token);
      } else {
        reject();
      }
    });
  },

  async registerDevice({ state, commit }) {
    if (!state.isOfflineMode) {
      return device.details().then(({ data }) => {
        commit('setDeviceDetails', data.result);
        commit('setSpace', data.result.space);
        localStorage.setItem('deviceDetails', JSON.stringify(data.result));
        localStorage.setItem('space', JSON.stringify(data.result.space));
        Promise.resolve(data.result);
      }).catch(err => Promise.reject(err));
    }

    return new Promise((resolve, reject) => {
      const deviceDetails = localStorage.getItem('deviceDetails');
      const space = localStorage.getItem('space');
      if (space) {
        commit('setDeviceDetails', JSON.parse(deviceDetails));
        commit('setSpace', JSON.parse(space));
        resolve(JSON.parse(deviceDetails));
      } else {
        reject();
      }
    });
  },

  async fetchBookings({ state, commit }, { date, spaceId }) {
    if (!state.isOfflineMode) {
      return device.getBookings(date, spaceId).then(({ data }) => {
        commit('setBookings', data.result);
        localStorage.setItem('bookings', JSON.stringify(data.result));
        Promise.resolve(data.result);
      }).catch(err => Promise.reject(err));
    }

    return new Promise((resolve, reject) => {
      const bookings = localStorage.getItem('bookings');
      if (bookings) {
        commit('setBookings', JSON.parse(bookings));
        resolve(bookings);
      } else {
        reject();
      }
    });
  },

  async refreshBookings({ state, dispatch }) {
    return dispatch('fetchBookings', { date: state.selectedDate.format('YYYY-MM-DD'), spaceId: state.space.id });
  },

  updateBooking({ commit }, { data, bookingId }) {
    const booking = Object.assign({}, data);
    if ('invites_list' in booking && !Array.isArray(booking.invites_list)) {
      booking.invites_list = JSON.parse(booking.invites_list);
    }

    commit('updateBooking', { data: booking, bookingId });
  },

  async fetchSpaces({ state, commit }) {
    if (!state.isOfflineMode) {
      return getSpaces().then(({ data }) => {
        commit('setSpaces', data.result);
        localStorage.setItem('spaces', JSON.stringify(data.result));
        Promise.resolve(data.result);
      }).catch(err => Promise.reject(err));
    }

    return new Promise((resolve, reject) => {
      const spaces = localStorage.getItem('spaces');
      if (spaces) {
        commit('setSpaces', JSON.parse(spaces));
        resolve(spaces);
      } else {
        reject();
      }
    });
  },

  async fetchCapAlertURLs({ commit }) {
    return getCAPAlerts().then(({ data }) => {
      commit('setCapAlertURLs', map(flatten(data.result), 'url'));
      Promise.resolve(data.result);
    }).catch(err => Promise.reject(err));
  },

  setPin({ dispatch, commit }, pin) {
    commit('setPin', pin);
    dispatch('togglePinCountDown', pin !== null);

    if (pin === null) return;

    (() => {
      let t = null;
      let v = null;

      function resetTimer() {
        clearTimeout(v);
        clearTimeout(t);

        dispatch('togglePinCountDown', false);
        // Start the timer after 10 seconds of inactivity
        v = setTimeout(() => {
          dispatch('togglePinCountDown', true);
          // Remove the PIN after 30 seconds
          t = setTimeout(() => {
            commit('setPin', null);
            clearTimeout(v);
          }, 30000);
        }, 2000);
      }

      document.onmousemove = resetTimer;
      document.onkeypress = resetTimer;
      document.ontouchstart = resetTimer;
      document.onclick = resetTimer;
      document.onmousedown = resetTimer;
      document.onscroll = resetTimer;
      resetTimer();
    })();
  },

  togglePinCountDown({ commit, state }, shouldStart) {
    if (state.startPinCountDown !== shouldStart) {
      commit('setPinCountDown', shouldStart);
    }
  },

  setDate({ commit }, date) {
    commit('setDate', date);
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js